// Mirrors the adminType -> admin_section_id mapping in
// services/authentication/models/adminUser.js (pre-save hook) on the backend.
export const ROLE = {
  SUPER: 1,
  ADMIN: 2,
  FINANCE: 3,
  ENGINEER: 4,
  FLIGHT: 5,
  MARKETING: 6,
  INSURANCE: 7,
};

export const hasRole = (admin, ids) => ids.includes(admin?.admin_section_id);

export const canViewFlights = (admin) =>
  hasRole(admin, [ROLE.SUPER, ROLE.ADMIN, ROLE.FLIGHT]);

export const canCancelBookings = (admin) =>
  hasRole(admin, [ROLE.SUPER, ROLE.FINANCE]);

export const canForceCancel = (admin) => hasRole(admin, [ROLE.SUPER]);
